import Button from "../../Button";
import Score from "../../Score/Score";
import { useContext, useState } from "react";
import constants from "../../../constants";
import RejectSvg from "../../../Svg/RejectSvg";
import { getDataFromStorage } from "../../../util";
import ProctorEyeSvg from "../../../Svg/ProctorEyeSvg";
import CommentsHooks from "../../../Hooks/CommentsHooks";
import AlertContext from "../../../context/AlertContext";
import ApproveSvgIcon from "../../../Svg/ApproveSvgIcon";
import CommentSvgIcon from "../../../Svg/CommentSvgIcon";
import CodingHeaderAdminSideHooks from "../../../Hooks/CodingPage/CodingHeaderAdminSideHooks";

import ProctoredPopup from "./ProctoredPopup";
import Tooltip from "../../CommonComponents/Tooltip";

export default function CodingHeaderAdminSide() {
  const Alert = useContext(AlertContext);

  const { toggleDrawer } = CommentsHooks();
  const CodingHeaderAdminSideHks = CodingHeaderAdminSideHooks();

  const [showProctoring, setShowProctoring] = useState(false);

  return (
    <div className="codingHeaderAdminSideMainContainer">
      <div className="codingHeaderAdminSideHeader">
        {CodingHeaderAdminSideHks.showSubmitButton(
          Object.keys(Alert.codeDetails).length !== 0
            ? Alert.codeDetails.status
            : Alert.mcqAndDesTestAndLpId.status,
        ) && (
          <Button
            size={"sm"}
            onClick={CodingHeaderAdminSideHks.adminSubmitTest}
            hierarchy={{
              type: "primary",
              buttonText: "Submit",
            }}
          />
        )}
        {(Alert.showBreadCrumbsData.status ===
          constants.PROGRESS_STATUS.EVALUATED ||
          Alert.showBreadCrumbsData.status ===
            constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
          Alert.showBreadCrumbsData.status ===
            constants.PROGRESS_STATUS.PARTIAL_EVALUATED) && <Score />}
        {(Alert.codeDetails?.notebook ||
          Alert.showBreadCrumbsData.testMode === constants.MODE.TEST_MODE ||
          Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT ||
          Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL) && (
          <>
            {Alert.showBreadCrumbsData.type !== constants.libTypeIds.MCQ &&
              Alert.showBreadCrumbsData.type !== constants.libTypeIds.SQL &&
              Alert.showBreadCrumbsData.type !==
                constants.libTypeIds.DESCRIPTIVE &&
              Alert.showBreadCrumbsData.type !==
                constants.libTypeIds.CODING_SNIPPET && (
                <Tooltip title="Approve" isIcon={true}>
                  <ApproveSvgIcon
                    onClick={CodingHeaderAdminSideHks.handleApprove}
                  />
                </Tooltip>
              )}
            {!Alert.showBreadCrumbsData.mockUse && (
              <Tooltip title="Reject" isIcon={true}>
                <RejectSvg onClick={CodingHeaderAdminSideHks.handleReject} />
              </Tooltip>
            )}
          </>
        )}
        {!Alert.isFromProfile.current &&
          Alert?.showBreadCrumbsData?.from !== "ccreportpage" &&
          !Alert.showBreadCrumbsData.mockUse &&
          getDataFromStorage("role") !== "customer" && (
            <Tooltip title="Comment" isIcon={true}>
              <CommentSvgIcon onClick={toggleDrawer("right", true)} />
            </Tooltip>
          )}
        {((Alert.showBreadCrumbsData.type !== constants.libTypeIds.ASSIGNMENT &&
          !Alert.isFromProfile.current &&
          getDataFromStorage("role") !== "customer") ||
          (Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT &&
            Alert.showBreadCrumbsData.proctored ===
              constants.PROCTORING_MODE.TAB_CAM &&
            !Alert.isFromProfile.current &&
            getDataFromStorage("role") !== "customer")) &&
          Alert?.showBreadCrumbsData?.from !== "ccreportpage" &&
          !Alert?.showBreadCrumbsData?.mockUse && (
            <Tooltip title="Proctoring" isIcon={true}>
              <ProctorEyeSvg onClick={() => setShowProctoring(true)} />
            </Tooltip>
          )}
      </div>

      <div style={{ marginTop: "55px", display: "flex", justifyContent: "center" }}>
        {showProctoring ? (
          <ProctoredPopup
            showProctoring={showProctoring}
            setShowProctoring={setShowProctoring}
          />
        ) : null}
      </div>
    </div>
  );
}
